import Vue from 'vue'
import { EagleModule } from 'kernel/types/module'

class moduleIndex {
  private vm: Vue| undefined
  public name: string
  constructor() {
    this.name = 'accounting'
  }

  public initVue(vm: Vue) {
    this.vm = vm
  }

  async launch(vm: Vue) : Promise<void>{

  }

  getModuleConfig() : EagleModule {
    return {
      launch: this.launch,
      menu: () => import('modules/accounting/config/menu'),
      realApi: () => import('modules/accounting/config/realApi'),
      routes: () => import('modules/accounting/config/route'),
    }
  }
}

export default new moduleIndex()
